import { useQuery, useMutation } from "react-query";
import {
  getAllCorporateContacts,
  createCorporateContact,
  updateCorporateContact,
} from "../../api/Onboarding/onboarding-corporate-contacts";

// Self service - get all corp contacts
const useGetAllCorporateContacts = (options = {}) => {
  const records = useQuery(
    "getAllCorporateContacts",
    getAllCorporateContacts,
    options,
  );
  return records;
};

// Self service - create single corp contact
const useCreateCorporateContact = (options = {}) => {
  return useMutation(createCorporateContact, options);
};

const useUpdateCorporateContact = (options = {}) => {
  return useMutation(updateCorporateContact, options);
};

export {
  useGetAllCorporateContacts,
  useCreateCorporateContact,
  useUpdateCorporateContact,
};
